@if (noframe) {
<div class="app-container" [ngClass]="{ 'ess-assist': isEss }">
  <app-navbar [hidden]="userInfo.showLoginPage"></app-navbar>
  <app-sidebar [hidden]="userInfo.showLoginPage"></app-sidebar>

  <div id="page">
    <router-outlet></router-outlet>
  </div>
</div>
}

<app-login-dialog></app-login-dialog>

@if (serverMessages?.length > 0) {
<div id="server-messages">
  @for (message of serverMessages; track message; let index = $index) {
  <div class="message" [ngClass]="{ 'good-message': message.success }" @message>
    <div (click)="dismissServerMessage(index)" class="delete icon"></div>
    <div class="heading">{{ message.heading }}</div>
    <div class="text">
      @if (isArray(message.message)) {
      <ul>
        @for (messageString of message.message; track messageString) {
        <li>
          {{ messageString }}
        </li>
        }
      </ul>
      } @else {

      <pre>{{ message.message }}</pre>

      }
    </div>
    <div class="date">{{ message.date }}</div>
    <div (click)="dismissAllMessages()" class="dismiss">ALL</div>
    <div (click)="dismissServerMessage(index)" class="dismiss">DISMISS /</div>
  </div>
  }
</div>
} @if (!noframe) {
<div class="app-container" [ngClass]="{ 'ess-assist': isEss }">
  Rubix does not load in iframe
</div>
}
